/*
  Custom Doussoux — product extras.
  Works on the product page AND in the Quick add / Quick edit windows
  (quick add from collections and from "También te puede gustar" in the cart, quick edit in the cart).

  1. "Agregar al carrito - €X" shows unit price × quantity (the price above stays static).
  2. A gradient ring runs once around the button whenever the amount changes:
     quantity + / −, or a model / size with a different price. In Quick edit it runs
     around "Actualizar".
  3. Variant buttons flash when selected, then stay black/white as usual:
       Fussion  : 80 / 76 / 72 / 68mm -> purple   ·   59mm -> teal
       ST       : electric blue (model and sizes)
       B21      : white (model and sizes)
       other    : purple
  Styles: assets/dsx-extras.css
*/
(function () {
  if (window.__dsxProductExtras) return;
  window.__dsxProductExtras = true;

  var SCOPES = ['.product-information-section', '.quick-action-dialog'];
  var SCOPE = SCOPES.join(', ');
  function inScopes(selector) {
    return SCOPES.map(function (s) { return s + ' ' + selector; }).join(', ');
  }

  /* ---------------- money helpers ---------------- */

  var NUMBER = /\d[\d.,\s  ']*\d|\d/;

  function formatLike(unitText, cents) {
    var m = unitText.match(NUMBER);
    if (!m) return null;
    var num = m[0];
    var dm = num.match(/([.,])(\d{2})$/);
    var dec = dm ? dm[1] : '';
    var intPart = dm ? num.slice(0, -3) : num;
    var thMatch = intPart.match(/[^\d]/);
    var th = thMatch ? thMatch[0] : dec === ',' ? '.' : ',';
    var whole = dec ? Math.floor(cents / 100) : Math.round(cents / 100);
    var out = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, th);
    if (dec) out += dec + String(cents % 100).padStart(2, '0');
    return unitText.slice(0, m.index) + out + unitText.slice(m.index + num.length);
  }

  function parseCents(text) {
    var m = text.match(NUMBER);
    if (!m) return null;
    var num = m[0];
    var dm = num.match(/([.,])(\d{2})$/);
    var whole = (dm ? num.slice(0, -3) : num).replace(/[^\d]/g, '');
    var cents = parseInt(whole || '0', 10) * 100 + (dm ? parseInt(dm[2], 10) : 0);
    return cents > 0 ? cents : null;
  }

  /* ---------------- scope helpers ---------------- */

  function scopes() {
    return document.querySelectorAll(SCOPE);
  }

  function qtyOf(scope) {
    var input = scope.querySelector('quantity-selector-component input[name="quantity"], input[name="quantity"]:not([type="hidden"])');
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  function variantOf(scope) {
    var input = scope.querySelector('form [name="id"], [name="id"]');
    return input ? String(input.value) : '';
  }

  function ringTarget(scope) {
    return scope.querySelector('.add-to-cart-button, .quick-edit__update-button');
  }

  function ring(button) {
    if (!button) return;
    button.classList.remove('dsx-atc-ring');
    void button.offsetWidth; // restart the animation
    button.classList.add('dsx-atc-ring');
    clearTimeout(button.__dsxRingT);
    button.__dsxRingT = setTimeout(function () {
      button.classList.remove('dsx-atc-ring');
    }, 950);
  }

  /*
    The unit price is read from the button itself: every time the theme re-renders it
    (new variant) it writes " - <unit price>" there. We keep that as the unit and write
    unit × quantity on top.
  */
  function refreshScope(scope) {
    var qty = qtyOf(scope);
    var signature = null;

    var button = scope.querySelector('.add-to-cart-button');
    var priceEl = button && button.querySelector('.add-to-cart-price');
    if (priceEl) {
      var current = priceEl.textContent;
      var vid = variantOf(scope);
      if (current !== button.__dsxWritten || vid !== button.__dsxVariant || !button.__dsxUnit) {
        var unitText = current.replace(/^\s*-\s*/, '').trim();
        var unit = parseCents(unitText);
        if (unit) {
          button.__dsxUnitText = unitText;
          button.__dsxUnit = unit;
          button.__dsxVariant = vid;
        }
      }
      if (button.__dsxUnit) {
        var total = formatLike(button.__dsxUnitText, button.__dsxUnit * qty);
        if (total) {
          var expected = ' - ' + total;
          if (current !== expected) priceEl.textContent = expected;
          button.__dsxWritten = expected;
          signature = expected;
        }
      }
    }

    // no price on the button (e.g. Quick edit "Actualizar"): shown price × quantity
    if (signature === null) {
      var shown = scope.querySelector('.product-price .price, .price');
      if (shown) signature = shown.textContent.trim() + ' x' + qty;
    }

    var target = ringTarget(scope);
    if (!target || signature === null) return;
    if (target.__dsxSig !== undefined && target.__dsxSig !== signature) ring(target);
    target.__dsxSig = signature;
  }

  function refreshAll() {
    scopes().forEach(refreshScope);
  }

  var pendingRefresh = false;
  function refreshSoon() {
    if (pendingRefresh) return;
    pendingRefresh = true;
    setTimeout(function () {
      pendingRefresh = false;
      refreshAll();
    }, 0);
  }

  function onQuantityChange(e) {
    var el = e.target;
    if (!el || !el.closest || !el.closest(SCOPE)) return;
    // the quantity component writes the new value right after the click: check a few times
    setTimeout(refreshAll, 0);
    setTimeout(refreshAll, 60);
    setTimeout(refreshAll, 250);
  }

  document.addEventListener('quantity-selector:update', onQuantityChange, true);
  ['input', 'change', 'blur', 'keyup'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.target && e.target.name === 'quantity') onQuantityChange(e);
    }, true);
  });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(inScopes('quantity-selector-component button') + ', ' + inScopes('.quantity-selector button'));
    if (b) onQuantityChange({ target: b });
  }, true);

  /* ---------------- variant flash ---------------- */

  function flashType(picker) {
    var vals = Array.prototype.map.call(picker.querySelectorAll('input:checked'), function (i) {
      return String(i.value || '').trim().toUpperCase();
    });
    var where = ((picker.getAttribute('data-product-url') || '') + ' ' + location.pathname).toLowerCase();
    if (vals.indexOf('B21') !== -1) return 'white';
    if (vals.indexOf('ST') !== -1 || vals.indexOf('ST.') !== -1) return 'blue';
    var fussion = where.indexOf('fussion') !== -1 || vals.some(function (v) { return v.indexOf('FUSSION') !== -1; });
    if (fussion) return vals.some(function (v) { return /^59/.test(v); }) ? 'teal' : 'purple';
    return 'purple';
  }

  // The theme re-renders ("morphs") the picker after every change and wipes our class,
  // so the flash starts on click and is put back (at the same point) after each re-render.
  var active = null; // { name, value, type, start }

  function findLabel() {
    if (!active) return null;
    var inputs = document.querySelectorAll(inScopes('variant-picker input[type="radio"]'));
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].name === active.name && inputs[i].value === active.value) {
        return inputs[i].closest('.variant-option__button-label');
      }
    }
    return null;
  }

  function applyFlash() {
    if (!active) return;
    var elapsed = performance.now() - active.start;
    if (elapsed > 850) return;
    var label = findLabel();
    if (!label) return;
    if (label.classList.contains('dsx-flash') && label.getAttribute('data-dsx-flash') === active.type) return;
    label.setAttribute('data-dsx-flash', active.type);
    label.style.setProperty('--dsx-flash-delay', -Math.round(elapsed) + 'ms');
    label.classList.add('dsx-flash');
  }

  function clearFlash() {
    document.querySelectorAll(inScopes('.variant-option__button-label.dsx-flash')).forEach(function (label) {
      label.classList.remove('dsx-flash');
      label.style.removeProperty('--dsx-flash-delay');
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.closest) return;
    var picker = input.closest(inScopes('variant-picker'));
    if (!picker) return;
    var previous = active;
    active = null;
    clearFlash();
    if (previous) void document.body.offsetWidth;
    active = { name: input.name, value: input.value, type: flashType(picker), start: performance.now() };
    applyFlash();
    clearTimeout(window.__dsxFlashEnd);
    window.__dsxFlashEnd = setTimeout(function () {
      active = null;
      clearFlash();
    }, 900);
  }, true);

  document.addEventListener('variant:update', function () {
    setTimeout(function () {
      applyFlash();
      refreshAll();
    }, 0);
  });

  /* ---------------- watch the page (and windows that open later) ---------------- */

  var observer = new MutationObserver(function (records) {
    if (active) applyFlash();
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (el && el.closest && el.closest(SCOPE)) { refreshSoon(); return; }
      if (records[i].addedNodes && records[i].addedNodes.length) { refreshSoon(); return; }
    }
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-dsx-flash'] });
    refreshAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
